import gql from 'graphql-tag';

export const GET_WORKSPACE_DATA_QUERY = gql`
  query GetWorkspaceQuery($workspaceIdInput: WorkspaceIdInput!) {
    workspace(workspaceIdInput: $workspaceIdInput) {
      id
      nodes {
        id
        role
        syncTableMeta {
          isEnabled
          isSourceTableDeleted
        }
        taskflow {
          views {
            todo
            done
            initiated
            all
          }
        }
      }
      users {
        id
        nickName
        image
        color
      }
    }
  }
`;
